import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { resendFormEmail } from '../../../../Services/adminApiService';
import { securePackageCopy } from '../../../../copy/securePackage';

const ResendEmailButton = ({ formType, formToken, onStatusUpdate }) => {
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleResend = async () => {
    if (!window.confirm('Resend the email notification for this form?')) return;

    setSending(true);
    setError(null);
    setSuccess(false);
    try {
      const data = await resendFormEmail(formType, formToken);
      if (onStatusUpdate) {
        onStatusUpdate(data.emailStatus);
      }
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      const status = err.response?.status;
      if (status === 404) {
        setError('Form not found.');
      } else if (status === 502) {
        if (onStatusUpdate) onStatusUpdate('FAILED');
        setError('Email service unavailable.');
      } else if (status === 403) {
        setError('No permission.');
      } else {
        setError('Resend failed.');
      }
      console.error('Resend email error:', err);
    } finally {
      setSending(false);
    }
  };

  return (
    <span className="resend-email-wrapper">
      <button
        onClick={handleResend}
        disabled={sending}
        className="btn-resend-email"
        title={securePackageCopy.fallbackOnly}
      >
        {sending ? 'Sending...' : 'Resend Email (Fallback)'}
      </button>
      {error && <span className="resend-email-error">{error}</span>}
      {success && <span className="resend-email-success">Sent!</span>}
    </span>
  );
};

ResendEmailButton.propTypes = {
  formType: PropTypes.string.isRequired,
  formToken: PropTypes.string.isRequired,
  onStatusUpdate: PropTypes.func,
};

ResendEmailButton.defaultProps = {
  onStatusUpdate: null,
};

export default ResendEmailButton;
